import { PlayerUpdate, Sweep } from '@inplay/models';

export type AddNewPlayerModalProps = {
  selectedPlayer: PlayerUpdate & { selectedOptionType?: SelectPlayerOption };
  selectedSweep: Sweep | undefined;
  onCloseSelectPlayerModal: () => void;
};

export enum SelectPlayerOption {
  Random = 'random',
  Existing = 'existing',
}
